// console.log('util.js is used')
import axios from 'axios'
// import * as Cookies from 'js-cookie' // for API call
// import * as Config from './config' // for API call

function getTimeago (timestamp) {
  var oldDate = new Date(timestamp)
  var nowDate = new Date()
  var timeGap = nowDate.getTime() - oldDate.getTime()

  var timeGapSec = timeGap / 1000
  var timeGapMin = timeGapSec / 60
  var timeGapHour = timeGapMin / 60
  var timeGapDay = timeGapHour / 24

  if (timeGapSec <= 60) {
    return parseInt(timeGapSec + 1) + '초전'
  } else if (timeGapMin < 60) {
    return parseInt(timeGapMin) + '분전'
  } else if (timeGapHour < 24) {
    return parseInt(timeGapHour) + '시간전'
  } else {
    return parseInt(timeGapDay) + '일전'
  }
}

function getRoomInfo () {
  axios.get('/nlivechat/ajax.rooms.php',
    {
      'cmd': 'all'
    },
    {
      'headers': {
        'cmd': 'all'
      }
    }
  ).then(function (response) {
    // console.log(response)
    var outputData = response.data
    var store = window.vm.$children[0].$store
    store.dispatch('setChatRooms', outputData)
  })
}

function enterChatRoom (uid, rank) {
  axios.post('/nlivechat/ajax.common.php', 'cmd=check_join&room_uid=' + uid + '&location=main',
    {
      headers: {
        'Accept': 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      withCredentials: true
    }
  ).then(response => {
    // console.log(response)
    let data = response.data
    if (data['need_password'] === 'Y') {
      alert('비밀방은 대기실에서 비밀번호를 입력후 입장가능합니다.')
      openRoomChatWindow('')
      return
    }
    if (data['returnCode'] === '999') {
      openRoomChatWindow(uid)
      return
    }
    if (data['returnCode'] === '100') { // 성공
      if (data['join_point'] > 0) {
        if (!confirm('입장시 포인트 ' + data['join_point'] + '점이 차감됩니다. 입장하시겠습니까? ')) {
          return
        }
      }

      openRoomChatWindow(uid)
    } else {
      alert(data['errorMsg'])
    }
  }).catch(errors => console.log(errors))
}

// API 사용 불가능으로 인하여 소스 사용 중지 (해결전까지)
// function getRoomInfoAPI () {
//   var config = {
//     'method': 'get',
//     'url': '/chat/rooms?orderBy=recom',
//     'baseURL': Config.OKIAPIURL,
//     'headers': {
//       'Accept': '*/*',
//       'Content-Type': 'application/json;charset=UTF-8',
//       'oki-api-name': Config.OKIAPINAME,
//       'oki-api-key': Config.OKIAPIKEY,
//       'oki-api-token': window.sessID === '' ? '' : Cookies.get('token'),
//       'Access-Control-Allow-Origin': '*',
//       'Access-Control-Allow-Method': 'GET',
//       'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, oki-api-name, oki-api-key, oki-api-token'
//     }
//   }
//   axios(config).then(function (response) {
//     var outputData = response.data
//     var store = window.vm.$children[0].$store
//     store.dispatch('setChatRooms', outputData)
//   }).catch(errors => console.warn(errors))
// }

// function enterChatRoomAPI (uid, rank) {
//   if (uid === undefined || uid === null || uid === 0) {
//     uid = ''
//   }
//   var config = {
//     'method': 'post',
//     'url': '/chat/room/' + uid + '/checkJoin',
//     'baseURL': Config.OKIAPIURL,
//     'headers': {
//       'Accept': '*/*',
//       'Content-Type': 'application/json;charset=UTF-8',
//       'oki-api-name': Config.OKIAPINAME,
//       'oki-api-key': Config.OKIAPIKEY,
//       'oki-api-token': window.sessID === '' ? '' : Cookies.get('token'),
//       'Access-Control-Allow-Origin': '*',
//       'Access-Control-Allow-Method': 'GET',
//       'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, oki-api-name, oki-api-key, oki-api-token'
//     },
//     'data': {
//       'chatRoomId': 'string',
//       'chatRoomPass': 'string'
//     }
//   }
//   axios(config)
//   .then(response => {
//     // console.log(response)
//     let data = response.data
//     // alert('[성공] window.sessID: ' + window.sessID + ' / data["joinPoint"]: ' + data['joinPoint'])
//     if (data['returnCode'] === '999') {
//       if (rank > 0 && rank <= 10) {
//       }
//       openRoomChatWindow(uid)
//       return
//     }
//     if (response['status'] === 200) { // 성공
//       if (data['joinPoint'] > 0 && window.sessID !== '') {
//         if (!confirm('입장시 포인트 ' + data['joinPoint'] + '점이 가 차감됩니다. 입장하시겠습니까? ')) {
//           return
//         }
//       }
//       if (rank > 0 && rank <= 10) {
//       }
//       openRoomChatWindow(uid)
//     }
//   }).catch(function (data) {
//     var statusCode = data.response.status
//     var errorCode = data.response.data.code
//     var errorMessage = data.response.data.message
//     // alert('[실패] window.sessID: ' + window.sessID + ' / statusCode: ' + statusCode + ' / errorCode: ' + errorCode + ' / errorMessage: ' + errorMessage)
//     if (statusCode === 400) { // paramater Error
//       if (errorCode === 'IncorrectInputPassword') {
//         alert('비밀방은 대기실에서 비밀번호를 입력후 입장가능합니다.') // original : 비밀번호가 맞지 않습니다.
//         openRoomChatWindow('')
//       } else if (errorCode === 'InvalidTokenError') {
//         alert(errorMessage)
//       } else if (errorCode === 'InvalidMessageIdError') {
//         alert(errorMessage)
//       } else if (errorCode === 'NotRoomPaidError') {
//         alert(errorMessage)
//         return
//       }
//       openRoomChatWindow(uid)
//     } else if (statusCode === 500) {
//       alert('네임드 내부 시스템 오류가 발생하였습니다.')
//     }
//   })
// }

function openRoomChatWindow (roomUid) {
  var url = ''
  if (!roomUid || roomUid === '') {
    url = '/nlivechat/chat_lobby.php'
  } else if (window.sessID === '') {
    url = '/nlivechat/guest_recaptcha.php?room_uid=' + roomUid
  } else {
    url = '/nlivechat/chat_room.php?room_uid=' + roomUid
  }
  // console.log('openRoomChatWindow', roomUid, url)
  window.open(url, '_blank', 'width=950, height=720, resize=yes scrollbar=no, scrolling=no')
}

function showContextMenu (elem) {
  // console.log('showContextMenu')
  var event = elem
  if (elem.event) {
    event = elem.event
  }
  // create menu html element
  event.preventDefault()
  event.stopPropagation()
  var chatContainer = document.getElementById('chatContextMenu')
  // console.log(event.target, event.target.getAttribute('rel'))
  chatContainer.childNodes[0].innerText = event.target.innerText
  chatContainer.childNodes[0].setAttribute('rel', event.target.getAttribute('rel'))
  var styles = chatContainer.style
  var isOverHeight = window.innerHeight - event.pageY < chatContainer.clientHeight
  var isOverWidth = window.innerWidth - event.pageX < 152
  if (isOverHeight) {
    styles.top = (event.pageY - chatContainer.clientHeight).toString() + 'px'
  } else {
    styles.top = event.pageY.toString() + 'px'
  }
  if (isOverWidth) {
    styles.left = '165px'
  } else {
    styles.left = event.pageX.toString() + 'px'
  }
  styles.opacity = '1'
  // console.log(event, event.offsetX, event.offsetY, event.pageX, event.pageY, isOverHeight, isOverWidth)
}

export { getRoomInfo, enterChatRoom, openRoomChatWindow, showContextMenu, getTimeago }



// WEBPACK FOOTER //
// ./src/util.js